import config from 'config'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import queryString from 'query-string'
import { withTranslation } from 'react-i18next'
import history, { redirectToBack } from 'srcReact/helpers/history'
import { getInitials, randomValue } from 'srcReact/helpers/utils'
import { isEmpty } from 'srcReact/helpers/validator'
import { workplaceActions } from 'srcReact/WorkplacePage'
import { alertActions } from 'srcReact/Alert'
import PageContainer from 'srcReact/PageContainer/PageContainer'
import styles from './styles.module.scss'
import NotAuthorizedError from 'srcReact/components/common2/NotAuthorizedError'
import AnchorLink from 'srcReact/components/common2/AnchorLink'
import Button from 'srcReact/components/common2/Button'
import RequiredStar from 'srcReact/components/common2/RequiredStar'
import { AlertContainer } from 'srcReact/Alert/AlertContainer'
import { Tip } from 'srcReact/components/common2/Tip'
import Tile from 'srcReact/components/common2/Tile'
import Spinner from 'srcReact/components/common2/Spinner'
import { TextBox } from 'srcReact/components/common2/TextBox'
import LocationTextBox from 'srcReact/components/common2/LocationTextBox'
import { appConstantSettings } from 'srcReact/appConstantSettings'

class CreateWorkplace extends Component {
  workplaceColors = ['red', 'green', 'violet']

  constructor(props) {
    super(props)

    const values = queryString.parse(this.props.location.search)
    if (typeof values.organization_id !== 'undefined') {
      this.props.canAccess('page-create-workplace', values.organization_id)
    } else {
      // nativeapp
      if (this.props.isNative) {
        window.location = config.webUrl + `/`
        return
      }
      history.push('/')
    }
    const { t } = props
    this.state = {
      name: '',
      location: {},
      color: randomValue(this.workplaceColors),
      organization_id: values.organization_id,
      submitted: false,
      workplace: {
        name: {
          value: '',
          placeholder: t('workplace.create.placeholder_name'),
          hasError: false,
          errorMessage: '',
          isRequired: true
        },
        location: {
          value: '',
          placeholder: t('workplace.create.placeholder_location'),
          hasError: false,
          errorMessage: '',
          isRequired: true
        }
      }
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleSelectLocation = this.handleSelectLocation.bind(this)
    this.handleSelectLocationBlur = this.handleSelectLocationBlur.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
    this.validate = this.validate.bind(this)
    this.handleClear = this.handleClear.bind(this)

    document.body.classList.add('create-workplace-page')
  }

  componentWillUnmount() {
    document.body.classList.remove('create-workplace-page')
  }

  handleClear() {
    const { t } = this.props
    this.setState((prevState) => ({
      ...prevState,
      workplace: {
        ...this.state.workplace,
        location: {
          ...this.state.workplace.location,
          value: null,
          hasError: true,
          errorMessage: t('error.required', { field: t(`formlabel.location`) })
        }
      }
    }))
  }

  validate(workplace) {
    let isValid = true
    const objToValidate = { ...workplace }

    for (const key in workplace) {
      if (!this.isFieldValid(objToValidate, key)) {
        isValid = false
      }
    }
    this.setState((prevState) => ({ workplace: { ...objToValidate } }))
    return isValid
  }

  handleBlur(e) {
    if (e && e.target) {
      const { name, value } = e.target
      if (!this.isFieldValid(this.state.workplace, name)) {
        this.setState((prevState) => ({
          ...prevState,
          workplace: {
            ...this.state.workplace,
            [name]: {
              ...this.state.workplace[name],
              value: value,
              hasError: true
            }
          }
        }))
      }
    }
  }

  handleChange(e) {
    if (this.state.submitted) {
      this.setState({ submitted: false })
    }
    const { name, value } = e.target

    this.setState((prevState) => ({
      ...prevState,
      workplace: {
        ...this.state.workplace,
        [name]: {
          ...this.state.workplace[name],
          value: value,
          hasError: false
        }
      }
    }))
  }

  isFieldValid(obj, key) {
    const { t } = this.props
    if (obj[key].isRequired && isEmpty(obj[key].value)) {
      obj[key] = {
        ...obj[key],
        hasError: true,
        errorMessage: t('error.required', { field: t(`formlabel.${key}`) })
      }
      return false
    } else if (key === 'email' && !isEmail(obj[key].value, true)) {
      obj[key] = {
        ...obj[key],
        hasError: true,
        errorMessage: t('error.invalid_email', { field: t(`formlabel.${key}`) })
      }
      return false
    }
    return true
  }
  handleSelectLocationBlur() {
    const { t } = this.props
    if (!this.state.workplace.location.value) {
      this.setState((prevState) => ({
        ...prevState,
        workplace: {
          ...this.state.workplace,
          location: {
            ...this.state.workplace.location,
            value: location.value,
            hasError: true,
            errorMessage: t('error.required', { field: t(`formlabel.location`) })
          }
        }
      }))
    }
  }

  handleSelectLocation(location) {
    if (this.state.submitted) {
      this.setState({ submitted: false })
    }
    this.setState((prevState) => ({
      ...prevState,
      workplace: {
        ...this.state.workplace,
        location: {
          ...this.state.workplace.location,
          value: location,
          hasError: false,
          errorMessage: ''
        }
      }
    }))
  }

  handleSubmit(e) {
    e.preventDefault()
    this.props.clearAlerts()

    this.setState({ submitted: true })

    if (this.validate(this.state.workplace)) {
      const {
        workplace: {
          name: { value: name },
          location: { value: location }
        },
        color,
        organization_id
      } = this.state
      this.props.create(organization_id, name, JSON.stringify(location), color)
    }
  }

  render() {
    const { t, isMobile, isNative, user, alert, workplace } = this.props
    const { new_workplace } = workplace
    const { organization_id, submitted, name, color, location } = this.state
    return (
      <React.Fragment>
        {alert && alert.message && (
          <AlertContainer
            title={t('error.error_alert_title')}
            message={alert.message}
            show={!!alert.message}
            handleClose={() => this.props.clearAlerts()}
          />
        )}
        <PageContainer pageTitle={t('workplace.create.pageTitle')} withFooter={false}>
          <div className={styles.createWP}>
            {workplace.ask_access_page && <Spinner />}

            {!workplace.ask_access_page && !workplace.authorized && <NotAuthorizedError />}
            {workplace.authorized && (
              <div className={styles.wrapper}>
                <div className={styles.header}>
                  <h1 className={styles.heading}>{t('workplace.create.title')}</h1>
                </div>
                <div className={styles.body}>
                  <div className={styles.back}>
                    <AnchorLink
                      aria-label={t('workplace.create.backAlt')}
                      children={t('workplace.create.back')}
                      icon={{
                        name: 'chevron-left',
                        position: 'start',
                        alt: '',
                        size: 'large',
                        styleModifier: styles.backLinkLeft
                      }}
                      handleClick={() => redirectToBack(isNative)}
                      className={styles.backLink}
                    />
                  </div>
                  <div className={styles.card}>
                    <div className={styles.cardOuter}>
                      <div className={styles.cardInner}>
                        <form name='form' className={styles.form} onSubmit={this.handleSubmit}>
                          <TextBox
                            label={t('workplace.create.label_name')}
                            isRequired={this.state.workplace['name'].isRequired}
                            customWrapperCss={`${styles.controlWrapper} ${styles.controlWrapperName}`}
                            customLabelCss={styles.formLabel}
                            customInputCss={styles.formInput}
                            customErrorCss={styles.formError}
                            onChange={this.handleChange}
                            onBlur={this.handleBlur}
                            name='name'
                            fieldInfo={this.state.workplace['name']}
                            placeholder={this.state.workplace['name'].placeholder}
                            maxLength={appConstantSettings.WP_NAME_MAXLENGTH}
                          />
                          <div className={styles.tileWrapper}>
                            <Tile size='medium' color={color} className={styles.tileCustomCSS} badge={t('global.new')}>
                              <span className={styles.tileText}>
                                {this.state.workplace.name.value.length > 30
                                  ? getInitials(this.state.workplace.name.value)
                                  : this.state.workplace.name.value}
                              </span>
                            </Tile>
                          </div>
                          <div className={`${styles.controlWrapper} ${styles.controlWrapperLocation}`}>
                            <label className={styles.formLabel} htmlFor='name'>
                              {t('workplace.create.label_location')}
                              {this.state.workplace['location'].isRequired && <RequiredStar bold={true} />}
                            </label>

                            <LocationTextBox
                              value={this.state.workplace['location']}
                              ariaLabel={t('workplace.create.label_location')}
                              placeholder={this.state.workplace['location'].placeholder}
                              locationContainerCSS={styles.locationTextbox}
                              handleSelectLocation={this.handleSelectLocation}
                              handleSelectLocationBlur={this.handleSelectLocationBlur}
                              handleClear={this.handleClear}
                              classNamePrefix='location'
                            />
                            {this.state.workplace['location'].hasError && (
                              <div role='alert' className={styles.formError}>
                                {this.state.workplace['location'].errorMessage}
                              </div>
                            )}
                          </div>
                          <div className={styles.buttonWrapper}>
                            <Button
                              type='submit'
                              size='large'
                              customStyle={styles.createWPButton}
                              text={
                                new_workplace && new_workplace.submitted ? <Spinner /> : t('workplace.create.submit')
                              }
                            />
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div className={styles.tip}>
                    <Tip position={isMobile ? 'bottom' : 'right'} text={t('workplace.create.tip')} />
                  </div>
                </div>
              </div>
            )}
          </div>
        </PageContainer>
      </React.Fragment>
    )
  }
}

function mapStateToProps(state) {
  const { login, workplace, common, alert } = state
  const { user } = login.user
  const { isMobile, isNative } = common
  return { alert, isMobile, isNative, user, workplace }
}

const actionCreators = {
  canAccess: workplaceActions.canAccess,
  create: workplaceActions.create,
  clearAlerts: alertActions.clear
}

const ExtendedComponent = withTranslation('common')(CreateWorkplace)

const connectedCreateWorkplacePageContainer = connect(mapStateToProps, actionCreators)(ExtendedComponent)
export { connectedCreateWorkplacePageContainer as CreateWorkplace }
